import { render, staticRenderFns } from "./ResellerInformation.vue?vue&type=template&id=79dc3a35&scoped=true&"
import script from "./ResellerInformation.vue?vue&type=script&lang=js&"
export * from "./ResellerInformation.vue?vue&type=script&lang=js&"
import style0 from "./ResellerInformation.vue?vue&type=style&index=0&id=79dc3a35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc3a35",
  null
  
)

export default component.exports